import { Dispatch, SetStateAction } from 'react';

interface tabStyles {
  activeStyle: string;
  inActiveStyle: string;
  isButton: boolean;
}
interface tabs {
  index: number;
  label: string;
  component: React.ComponentType<CALCULATOR_TAB_PROPS>;
}
export interface tabsData {
  tabStyles: tabStyles;
  tabs: tabs[];
}

export interface BusinessProfessions {
  id: number;
  Type: string;
  Amount: string;
}

export interface TaxPaidAmount {
  id: number;
  Date: string;
  Amount: string;
}

export interface CapitalGains {
  id: number;
  Category?: string;
  HoldingPeriod: string;
  GainOrLoss: string | number;
}
export interface CALCULATOR_DATA {
  [key: string]:
    | number
    | string
    | BusinessProfessions[]
    | TaxPaidAmount[]
    | CapitalGains[];
}
interface CALCULATOR_TAB {
  hasError?: boolean;
  setGlobalError?: Dispatch<SetStateAction<boolean>>;
  inputTabData?: CALCULATOR_DATA;
  setInputData?: Dispatch<SetStateAction<CALCULATOR_DATA>>;
  showCalculation?: SHOW_CALCULATION;
  setShowCalculation?: Dispatch<SetStateAction<SHOW_CALCULATION>>;
  activeTab?: number;
  setTaxResult?: React.Dispatch<React.SetStateAction<TAX_RESULT | null>>;
}

export interface CALCULATOR_TAB_PROPS extends CALCULATOR_TAB {
  taxCalculation?: TAX_REGIMES;
}

export interface CALCULATOR_TAB_PROPS_ATC extends CALCULATOR_TAB {
  taxCalculation?: ATC_REGIMES;
}

export interface SHOW_CALCULATION {
  displayCalculation: boolean;
  renderCalculation: boolean;
}

interface TaxData {
  taxableIncome: string;
  taxPayable: string;
  healthAndEducationCess: string;
  exemptionsAndDeductionsInSalary: string;
  standardDeductions: string;
  incomeTaxInclusiveOfSpecialRate: string;
  totalIncome: string;
  taxable_Income: string;
  grossTax: string;
  totalDeductions: string;
  surcharge: string;
}

interface RegimeDataMap {
  newBudgetNewRegime: TaxData;
  newBudgetOldRegime: TaxData;
}

export interface TAX_REGIMES extends RegimeDataMap {
  isOldSchemeSuggested: boolean;
}

export const taxRegimeMap: { [key: number]: keyof RegimeDataMap } = {
  0: 'newBudgetNewRegime',
  1: 'newBudgetOldRegime',
};
interface Atctabs {
  index: number;
  label: string;
  component: React.ComponentType<CALCULATOR_TAB_PROPS_ATC>;
}
export interface AtctabsData {
  tabStyles: tabStyles;
  tabs: Atctabs[];
}

interface advanceTaxQuarterProps {
  [key: string]: {
    period: string;
    percentageToBeDeposited: string;
    taxToBeDeposited: string;
    taxPaid: string;
    taxDueForQuarter: string;
  };
}

export interface ATC_DATA {
  netTaxLiability: string;
  currentPayable: string;
  totalAdvanceTaxDue: string;
  advanceTaxQuarterResults: advanceTaxQuarterProps;
}
export interface AtcRegimeDataMap {
  oldRegimeCalculations: ATC_DATA;
  newRegimeCalculations: ATC_DATA;
}
export interface ATC_REGIMES extends AtcRegimeDataMap {
  lastDateOfCurrentQuarter: string;
  totalAdvanceTaxPaid: string;
  preferredRegime: string;
  newRegime: string;
  oldRegime: string;
}
export const AtcRegimeMap: { [key: number]: keyof AtcRegimeDataMap } = {
  0: 'oldRegimeCalculations',
  1: 'newRegimeCalculations',
};
export interface TAX_RESULT {
  newBudgetOldRegime: {
    grossTax: string | number;
  };
  newBudgetNewRegime: {
    grossTax: string | number;
  };
}
